// extracted by mini-css-extract-plugin
module.exports = {"video-player":"VideoPlayer_video-player__1Z60z","close-button":"VideoPlayer_close-button__xQDql"};